import StyledComponentProps from 'utils/types/styled-components-type';
import styled from 'styled-components';

export const Drawer = styled.div<StyledComponentProps>`
  height: 100%;
  position: fixed;
  z-index: 1;
  top: 0;
  right: 0;
  background-color: var(--heltar-bg-primary);
  overflow-x: hidden;
  transition: 0.1s;
  margin-top: 65.5px;
  box-shadow: var(--shadow2-color);
  width: ${props => (props.isDrawer ? '300px' : '0')};
`;

export const NewIcon = styled.img<StyledComponentProps>`
  height: ${props => (props.height ? props.height : 'auto')} !important;
  max-height: ${props =>
    props.maxheight ? props.maxheight : 'auto'} !important;
  width: ${props => (props.width ? props.width : 'auto')} !important;
  object-fit: ${props =>
    props.objectfit ? props.objectfit : 'cover'} !important;
  margin-left: ${props =>
    props.marginleft ? props.marginleft : '0'} !important;
  margin-right: ${props =>
    props.marginright ? props.marginright : '0'} !important;
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0'} !important;
  margin-top: ${props => (props.margintop ? props.margintop : '0')} !important;
  border-radius: ${props =>
    props.borderradius ? props.borderradius : '0'} !important;
  cursor: ${props => (props.cursor ? props.cursor : 'pointer')};
  padding: ${props => (props.padding ? props.padding : '0')}!important;
  overflow: ${props => props.overflow || 'auto'};
  filter: ${props => (props.filter ? props.filter : 'none')};
  position: ${props => (props.position ? props.position : 'auto')};
  top: ${props => (props.top ? props.top : '0')};
`;

export const NewVideo = styled.video<StyledComponentProps>`
  height: ${props => (props.height ? props.height : 'auto')} !important;
  max-height: ${props =>
    props.maxheight ? props.maxheight : 'auto'} !important;
  width: ${props => (props.width ? props.width : 'auto')} !important;
  object-fit: ${props =>
    props.objectfit ? props.objectfit : 'cover'} !important;
  margin-left: ${props =>
    props.marginleft ? props.marginleft : '0'} !important;
  margin-right: ${props =>
    props.marginright ? props.marginright : '0'} !important;
  margin-bottom: ${props =>
    props.marginbottom ? props.marginbottom : '0'} !important;
  margin-top: ${props => (props.margintop ? props.margintop : '0')} !important;
  border-radius: ${props =>
    props.borderradius ? props.borderradius : '0'} !important;
  cursor: ${props => (props.cursor ? props.cursor : 'pointer')};
  padding: ${props => (props.padding ? props.padding : '0')} !important;
  overflow: ${props => props.overflow || 'auto'};
  filter: ${props => (props.filter ? props.filter : 'none')};
  position: ${props => (props.position ? props.position : 'auto')};
  top: ${props => (props.top ? props.top : '0')};
`;

export const Modal = styled.div<StyledComponentProps>`
  position: ${props => (props.position ? props.position : 'fixed')};
  top: ${props => (props.top ? props.top : '0')};
  left: ${props => (props.left ? props.left : '0')};
  height: ${props => (props.height ? props.height : 'auto')};
  padding-top: ${props =>
    props.paddingtop ? props.paddingtop : '0'} !important;
  padding-bottom: ${props =>
    props.paddingbottom ? props.paddingbottom : '0'} !important;
  right: ${props => (props.right ? props.right : '0')};
  bottom: ${props => (props.bottom ? props.bottom : '0')};
  display: ${props => props.display || 'flex'};
  align-items: ${props => props.alignitems || 'center'};
  justify-content: ${props => props.justifycontent || 'center'};
  background: ${props =>
    props.background || 'var(--heltar-shadow-subtle-color-v6)'};
  z-index: ${props => props.zindex || '1'};
`;

export const NewButton = styled.button<StyledComponentProps>`
  font-weight: ${props => props.fontweight || '400'};
  color: ${props => props.color || 'var(--heltar-text-on-brand)'};
  background-color: ${props => props.backgroundcolor || 'undefined'};
  background: ${props =>
    props.background ||
    'linear-gradient(to bottom, var(--heltar-brand-primary), var(--heltar-brand-primary))'};
  border-radius: ${props => props.borderradius || '5px'};
  border: ${props => props.border || 'none'};
  display: ${props => props.display || 'auto'};
  justify-content: ${props => props.justifycontent || 'auto'};
  align-items: ${props => props.alignitems || 'auto'};
  font-size: ${props => props.fontsize || '16px'};
  text-align: ${props => props.textalign || 'center'};
  margin-left: ${props => props.marginleft || '0'};
  margin-right: ${props => props.marginright || '0'};
  margin-top: ${props => props.margintop || '0'};
  margin-bottom: ${props => props.marginbottom || '0'};
  padding: ${props => props.padding || '8px 10px'};
  height: ${props => props.height || 'auto'};
  width: ${props => props.width || 'auto'};
  outline: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: ${props => props.cursor || 'pointer'};
  &:hover {
    background: ${props =>
      props.background ||
      'linear-gradient(to bottom, var(--heltar-brand-secondary), var(--heltar-brand-secondary))'};
  }
`;

export const BoxDesign = styled.div<StyledComponentProps>`
  font-weight: ${props => props.fontweight || '400'};
  color: ${props => props.color || 'var(--heltar-text-primary)'};
  background-color: ${props =>
    props.backgroundcolor || 'var(--heltar-bg-primary)'};
  border-radius: ${props => props.borderradius || '5px'};
  font-size: ${props => props.fontsize || '16px'};
  text-align: ${props => props.textalign || 'center'};
  margin-left: ${props => props.marginleft || '0'};
  margin-right: ${props => props.marginright || '0'};
  margin-top: ${props => props.margintop || '0'};
  margin-bottom: ${props => props.marginbottom || '0'};
  padding: ${props => props.padding || '8px 10px'};
  height: ${props => props.height || 'auto'};
  width: ${props => props.width || 'auto'};
  outline: none;
  border: ${props => props.border || 'none'};
  overflow: ${props => props.overflow || 'auto'};
  box-shadow: ${props =>
    props.boxshadow || 'var(--heltar-shadow-subtle-color-only) 0px 5px 15px'};
  display: ${props => props.display || 'auto'};
  flex-direction: ${props => props.flexdirection || 'auto'};
`;

export const Input = styled.input<StyledComponentProps>`
  outline: none;
  height: ${props => props.height || '50px'};
  width: ${props => props.width || 'auto'};
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '8px 10px'};
  background-color: ${props =>
    props.backgroundcolor || 'var(--heltar-bg-primary)'};
  border: ${props => props.border || '2px solid var(--heltar-gray)'};
  border-radius: ${props => props.borderradius || '8px'};
  box-sizing: border-box;
  &:hover,
  &:focus {
    border-color: var(--heltar-border-default);
    transition: border-color 0.3s;
  }
`;

export const Select = styled.select<StyledComponentProps>`
  outline: none;
  height: ${props => props.height || '50px'};
  width: ${props => props.width || 'auto'};
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '8px 10px'};
  border: ${props => props.border || '2px solid var(--heltar-gray)'};
  border-radius: ${props => props.borderradius || '8px'};
  box-sizing: border-box;
`;

export const TextArea = styled.textarea<StyledComponentProps>`
  outline: none;
  background-color: ${props =>
    props.backgroundcolor || 'var(--heltar-bg-primary)'};
  resize: ${props => props.resize || 'none'};
  height: ${props => props.height || 'auto'};
  width: ${props => props.width || 'auto'};
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '8px 10px'};
  border: 2px solid var(--heltar-gray);
  border-radius: ${props => props.borderradius || '8px'};
  box-sizing: border-box;
  &:hover,
  &:focus {
    border-color: var(--heltar-border-default);
    transition: border-color 0.3s;
  }
`;

export const DropDown = styled.div<StyledComponentProps>`
  position: absolute;
  background-color: ${props =>
    props.backgroundcolor || 'var(--heltar-bg-dropdown)'};
  box-shadow: ${props =>
    props.boxshadow ||
    '0 2px 5px 0 var(--heltar-shadow-subtle-color-only),0 2px 10px 0 var(--heltar-shadow-subtle-color-only)'};
  font-size: ${props => props.fontsize || '15px'};
  padding: ${props => props.padding || '8px 10px'};
  border-radius: ${props => props.borderradius || '5px'};
  width: ${props => props.width || 'auto'};
  margin: ${props => props.margin || '102px 60px 0 0'};
  top: ${props => (props.top ? props.top : '')};
  left: ${props => (props.left ? props.left : '')};
  right: ${props => (props.right ? props.right : '')};
  bottom: ${props => (props.bottom ? props.bottom : '')};
  opacity: ${props => props.opacity || 1};
  z-index: ${props => props.zindex || 1};
`;

export const Row = styled.div<StyledComponentProps>`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: ${props => props.padding || '0px 4px'};
`;

export const Col = styled.div`
  -ms-flex: 50%;
  flex: 50%;
  padding: 0 4px;
  margin-top: 8px;
  vertical-align: middle;
`;

export const NewP = styled.p<StyledComponentProps>`
  letter-spacing: 0;
  width: ${props => props.width || 'auto'} !important;
  color: ${props => (props.color ? props.color : 'var(--heltar-text-primary)')};
  font-size: ${props => (props.fontsize ? props.fontsize : '14px')};
  font-weight: ${props => (props.fontweight ? props.fontweight : '400')};
  margin: ${props => (props.margin ? props.margin : '0')};
  text-align: ${props => (props.textalign ? props.textalign : 'initial')};
  padding: ${props => (props.padding ? props.padding : '0')};
  cursor: ${props => (props.cursor ? props.cursor : 'arrow')};
  text-overflow: ellipsis;
  white-space: ${props => (props.whitespace ? props.whitespace : 'nowrap')};
  overflow: ${props => (props.overflow ? props.overflow : 'hidden')};
`;

export const TableContainer = styled.div`
  overflow: auto;
  width: calc(100% - 20px);
  border-radius: 10px;
  margin: 0 10px;
`;

export const RowHover = styled.div`
  display: flex;
  height: 60px;
  border-bottom: 1px solid var(--heltar-bg-surface-muted);
  cursor: pointer;

  &.odd {
    background-color: var(--heltar-bg-surface-elevated);
  }

  &.even {
    background-color: var(--heltar-bg-surface);
  }

  &:hover {
    background-color: var(--heltar-bg-surface-muted);
  }
`;

export const HeaderRow = styled.div`
  display: flex;
`;

export const Cell = styled.div<StyledComponentProps>`
  width: ${props => props.width || '280px'};
  min-width: ${props => props.width || '280px'};
  padding: 15px 20px;
  display: flex;
  align-items: center;
`;

export const HeaderCell = styled(Cell)`
  width: ${props => props.width || '280px'};
  min-width: ${props => props.width || '280px'};
  height: 70px;
  background-color: var(--heltar-bg-table-header);
  &:first-child {
    border-top-left-radius: 10px;
  }

  &:last-child {
    border-top-right-radius: 10px;
  }

  &:hover {
    background-color: var(--heltar-bg-table-header-hover);
  }
`;

export const StyledP = styled(NewP)`
  margin: 0;
  font-size: 16px;
`;

export const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 0%;
  background-color: var(--heltar-gray);
`;

export const Link = styled.a<StyledComponentProps>`
  text-decoration: none;
  color: ${props => (props.color ? props.color : 'var(--heltar-text-link)')};
  font-size: 14px;
`;
